import { jsx as t } from "react/jsx-runtime";
import { Heading as e } from "../../Heading/Heading.js";
const m = ({
  ...r
}) => /* @__PURE__ */ t(e, { size: "xs", ...r });
export {
  m as AlertTitle
};
